import _asyncToGenerator from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
import ApiService from "./ApiService";
import authService from "../AuthService";

var ProfileApiService = /*#__PURE__*/function (_ApiService) {
  _inherits(ProfileApiService, _ApiService);

  var _super = _createSuper(ProfileApiService);

  function ProfileApiService() {
    _classCallCheck(this, ProfileApiService);

    return _super.apply(this, arguments);
  }

  _createClass(ProfileApiService, [{
    key: "me",
    value:
    /**
     *
     * @returns {Promise}
     */
    function () {
      var _me = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$this$axios$get, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get("auth/me");

              case 3:
                _yield$this$axios$get = _context.sent;
                data = _yield$this$axios$get.data;
                authService.updateUserData(data);
                return _context.abrupt("return", data);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", this.throwFetchError(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function me() {
        return _me.apply(this, arguments);
      }

      return me;
    }()
    /**
     *
     * @returns {Promise}
     */

  }, {
    key: "managedProviders",
    value: function () {
      var _managedProviders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, _res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!authService.privileged) {
                  _context2.next = 11;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return this.axios.get("admins/providers");

              case 4:
                res = _context2.sent;
                return _context2.abrupt("return", res.data);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", this.throwFetchError(_context2.t0));

              case 11:
                _context2.prev = 11;
                _context2.next = 14;
                return this.axios.get("providers/employees/".concat(authService.id, "/shops"));

              case 14:
                _res = _context2.sent;
                return _context2.abrupt("return", _res.data);

              case 18:
                _context2.prev = 18;
                _context2.t1 = _context2["catch"](11);
                return _context2.abrupt("return", this.throwFetchError(_context2.t1));

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8], [11, 18]]);
      }));

      function managedProviders() {
        return _managedProviders.apply(this, arguments);
      }

      return managedProviders;
    }()
  }]);

  return ProfileApiService;
}(ApiService);

var profileApiService = new ProfileApiService();
export default profileApiService;